import React, { useMemo, useState } from 'react';
import { XIcon } from 'lucide-react';
function getTomorrowDate(): string {
  const tomorrow = new Date();
  tomorrow.setDate(tomorrow.getDate() + 1);
  const month = tomorrow.toLocaleString('en-US', {
    month: 'long'
  });
  const day = tomorrow.getDate();
  return `Tomorrow, ${month} ${day}`;
}
export function UrgencyStrip() {
  const [dismissed, setDismissed] = useState(false);
  const tomorrowStr = useMemo(() => getTomorrowDate(), []);
  if (dismissed) return null;
  return <div className="fixed top-0 left-0 right-0 z-[9999] bg-[#FF0000] flex items-center justify-center px-10 py-1.5" role="alert" data-id="element-601">
      <p className="font-sans text-[11px] sm:text-sm font-bold text-white text-center leading-snug" data-id="element-602">
        <span data-id="element-603">🔥 Launch Price: $6.37. Price increases to $142 on: </span>
        <span className="underline decoration-white/60" data-id="element-604">{tomorrowStr}</span>
      </p>

      <button onClick={() => setDismissed(true)} className="absolute right-2 sm:right-4 top-1/2 -translate-y-1/2 text-white/80 hover:text-white transition-colors p-1" aria-label="Dismiss banner" data-id="element-605">
        <XIcon className="w-4 h-4" data-id="element-606" />
      </button>
    </div>;
}